export default __webpack_public_path__ + "static/media/plus.3cbd7c4c.svg";